import * as React from 'react';
import { TabsProps } from './types';
import { TabButton } from './tab-button';
import { contentPanelId, labelId } from './selectors';

import style from './tabs.scss';

export const Tabs: React.FC<TabsProps> = (props) => {

  const { id, options, selectedOption, readOnly, onChange, children } = props;

  if (!options || options.length === 0) {
    return null;
  }

  const active = selectedOption || options[0];

  return <div className={style.tabsContainer}>
    <div className={style.tabs}>
      <ul role="tablist">
        {options.map((option) => {

          const isSelected = option.value === active.value;

          return <TabButton
            id={id}
            key={option.value}
            option={option}
            selected={isSelected}
            readOnly={readOnly}
            onChange={!isSelected && onChange}
          />;
        })}
      </ul>
    </div>
    <div className={style.content} id={contentPanelId(id)} role="tabpanel" aria-labelledby={labelId(id, active.value)} >
      {children}
    </div>
  </div>;
};
